/**
 * System admin page for managing document templates. Mounts the shared
 * DocumentTemplateManager at system scope.
 */
import DocumentTemplateManager from '../../components/document-templates/DocumentTemplateManager'

const ConsoleDocumentTemplates = () => (
  <DocumentTemplateManager
    scope={{ level: 'system' }}
    subtitle="System-wide document templates curated by Overmatch. Changes here cascade to all offices, program managers, and programs unless they've customized."
  />
)

export default ConsoleDocumentTemplates
